import React from "react";
import Loader from 'react-loader-spinner'
import { getBoundingClientRect } from "../../utils/functions";
import HttpService from '../../utils/Http.services';
import { checkTextTranslation, checkTranslation, getObject, translate } from "../../utils/useful";
import FixedView from "../FixedView";
import SidebarView from "../SidebarView";
import ItemModal from "../../modals/ItemModal";


class MultiSelectInput extends React.Component {

    state = {
        isOpen: false,
        data: [],
        title: '',
        tempData: [],
        options: [],
        isLoading: false,
        choosen: [],
        page: {
            fetchUrl: 'getInputOptions',
            addUrl: 'saveInputOptions',
            editUrl: 'saveInputOptions',
            removeUrl: 'removeInputOptions',
            headers: [
                { key: 'label', type: 'TextInput', col: '12', information: { label: '{{lang}}Label', inplaceEditable: false, placeholder: '{{lang}}desk.insert', required: true }, showMain: true },
                { key: 'colors', type: 'AdvancedColorInput', col: '12', information: { label: '{{lang}}Color', inplaceEditable: false, placeholder: '{{lang}}Color', required: false }, showMain: false },
                { key: 'parent', type: 'SelectInput', col: '12', information: { label: '{{lang}}Parent', address: 'getInputOptions', filter: this.props.header.information.filter, fields: { title: 'label', value: '_id', colors: 'colors' }, type: 'api', isSearchable: true, placeholder: '{{lang}}Select ...', required: false }, showMain: false },

                { key: 'description', type: 'TextAreaInput', col: '12', information: { label: '{{lang}}Description', inplaceEditable: false, placeholder: '{{lang}}desk.insert', required: false }, showMain: false },

            ]
        },

        // lastNewId: 0

    }

    toggleOpen = (open) => {
        // console.log("HERE")
        let openState = open != null ? open : !this.state.isOpen

        if (this.state.editIsOpen) {
            openState = false
        }
        if (openState) {
            // document.addEventListener('mousedown', this.fixedView.hideView);
            // window.addEventListener('scroll', this.fixedView.showView, true);
            // this.getPosition()
            this.fixedView.showView()

        } else {
            // document.removeEventListener('mousedown', this.fixedView.hideView);
            // window.removeEventListener('scroll', this.fixedView.showView);
            this.fixedView.hideView()


        }


        // this.refs.icon.classList.toggle("rotate-180")

        this.setState({ isOpen: openState, data: this.props.data })

    }

    // openBox = () => {

    //     if (!this.state.isOpen) {
    //         document.addEventListener('mousedown', this.closeBox);
    //     }
    //     // this.refs.icon.classList.toggle("rotate-180")

    //     this.setState({ isOpen: true, data: this.props.data })

    // }

    closeBox = (event) => {
        if (this.wrapperRef && !this.wrapperRef.contains(event.target) && this.state.isOpen) {
            this.setState({ isOpen: false, data: this.props.data })
            document.removeEventListener('mousedown', this.closeBox);
            window.removeEventListener('scroll', this.getPosition);
            // this.refs.icon.classList.toggle("rotate-180")
        }
    }


    getPosition = () => {
        // console.log("getPosition")
        let rect = getBoundingClientRect(this.wrapperRef)
        this.setState({ top: rect.top + 35, left: rect.left - 10 })
    }


    changeItem = (prop, selected, dontChangeValue) => {

        // console.log("CHANGE")
        var choosen = this.state.choosen
        this.setState({ title: '' }, () => {
            if (this.refs.input)
                this.refs.input.focus()
        })


        if (selected) {
            for (let i = 0; i < choosen.length; i++) {

                if (choosen[i].value == prop.value) {
                    choosen.splice(i, 1)
                }
            }
        } else {
            choosen.push(prop)
        }

        this.setState({ choosen }, () => {
            if (!dontChangeValue) this.changeValue()
        })

        setTimeout(() => {
            this.toggleOpen(true)
        }, 1);

        // setTimeout(
        //     function () {
        //         this.toggleOpen()
        //     }
        //         .bind(this),
        //     1
        // );


        if (this.state.tempData.length > 0)
            this.setState({ options: this.state.tempData })

        // this.changeFilter(prop.value)

    }

    setWrapperRef(node) {
        this.wrapperRef = node;
    }


    componentDidMount() {
        this.mounted = true
        // console.log(this.props.data)
        this.init()

    }

    componentDidUpdate(prevProps) {
        // console.log(this.props.data)

        if (prevProps.data != this.props.data && this.mounted) {
            // this.init()
        }
    }

    componentWillUnmount() {
        this.mounted = false
    }


    init() {
        if (this.props.header.information) {
            // if (this.props.header.information.type == "local") {

            //     let options = []
            //     let choosen = []

            //     if (this.props.header.information.items && this.props.header.information.items.length > 0) {
            //         options = this.props.header.information.items
            //     }

            //     if (this.props.title && Array.isArray(this.props.title)) {
            //         this.props.title.forEach(element => {
            //             choosen.push({ title: element, value: element })
            //         });
            //     }
            //     // console.log(this.props.title)
            //     this.setState({ options, choosen })
            // } else if (this.props.header.information.type == "api") {
            // console.log(this.props.title)
            this.fetch()
            // }
        }
    }


    fetch() {
        this.setState({ isLoading: true })
        let address = this.props.header.information.address
        let filter = typeof this.props.header.information.filter == "string" ? JSON.parse(this.props.header.information.filter) : this.props.header.information.filter

        if (filter && typeof filter == 'object') {
            for (const [key, value] of Object.entries(filter)) {
                if (/\{\{(.*?)\}\}/.test(value)) {
                    if (this.props.variables) {
                        filter[key] = this.props.variables[value.replace(/{/g, '').replace(/}/g, '')]
                    }
                }
            }
        }

        // console.log(this.props.variables)

        // console.log(filter)

        HttpService.request(address, filter, (fetchResult, fetchError) => {

            this.setState({ isLoading: false })
            // console.log(fetchError)


            if (fetchError) { return }

            // console.log(fetchResult)
            // fetch(address, {
            //     method: 'POST',
            //     body: JSON.stringify(filter),
            //     headers: headers
            // }).then(response => response.json()).then(data => {
            // console.log(data)
            // if (data.status == 200 && this.mounted) {
            let newData = []
            fetchResult.info.forEach(element => {

                let newTitle = getObject(element, this.props.header.information.fields.title)
                let newValue = getObject(element, this.props.header.information.fields.value)
                let newParent = getObject(element, this.props.header.information.fields.parent)
                let newColors = getObject(element, this.props.header.information.fields.colors)

                newData.push({ value: newValue, title: newTitle, parent: newParent, colors: newColors })
                // var newTitle = this.spliter(element, this.props.header.information.fields.title)
                // var newValue = this.spliter(element, this.props.header.information.fields.value)

                // newData.push({ value: newValue, title: newTitle })
            });

            // console.log(this.props.data)

            if (Array.isArray(this.props.data)) {
                let choosen = []
                this.props.data.forEach(oneTitle => {
                    let oneTitleId = typeof oneTitle == 'object' ? oneTitle._id : oneTitle
                    newData.forEach(oneNewData => {

                        if (oneNewData.value == oneTitleId) {
                            choosen.push(oneNewData)
                        }
                    });

                })
                this.setState({ choosen })
                // console.log(choosen)


            }

            let nestedData = []

            this.toNestedArray(nestedData, newData, null, () => {

            })

            // console.log(nestedData)
            this.setState({
                options: nestedData,
                isLoading: false
            })
        })

        // }).catch(error => this.setState({ error, isLoading: false }));
    }



    toNestedArray = (nestedData, data, parent) => {
        data.forEach(element => {
            if (element.parent == parent) {
                element.children = []

                this.toNestedArray(element.children, data, element.value)

                nestedData.push(element)

            }
        });
    }


    spliter(source, string) {
        var stringArray = string.split('.')
        var finalString = source
        stringArray.forEach(element => {
            finalString = finalString[element]
        });
        return finalString
    }


    // conditionalSettings(param, condition) {
    //     if (this.props.settings) {
    //         if (this.props.settings[param] == condition) {
    //             return true
    //         }
    //     }
    //     return false
    // }


    search = async (value) => {

        // console.log(value)
        this.setState({ title: value })
        if (!this.state.isOpen) {
            this.toggleOpen()
        }

        if (value == "") {
            await this.setState({ options: this.state.tempData })
            await this.setState({ tempData: [] })
        } else {
            if (this.state.tempData.length == 0) {
                await this.setState({ tempData: this.state.options })
            }
            var values = []
            // var values = this.props.data.filter((e) => e.title === value)
            // console.log(this.state.tempData)
            this.state.tempData.forEach(element => {
                if (String(element.title).toLowerCase().includes(String(value).toLowerCase())) {
                    values.push(element)
                }
            })
            // console.log(values)

            this.setState({ options: values })

            // }
        }
    }


    removeItem(index) {
        let choosen = [...this.state.choosen]
        choosen.splice(index, 1)
        this.setState({ choosen }, () => {
            this.changeValue()
        })
    }


    addTag() {
        let tempData = [...this.state.tempData]
        let choosen = [...this.state.choosen]

        let item = { title: this.state.title, value: this.state.title }
        tempData.push(item)
        // choosen.push(item)
        this.setState({ tempData }, () => {
            this.changeItem(item, false)
        })
        this.refs.input.focus()
    }

    changeValue() {
        let choosen = []
        this.state.choosen.forEach(element => {
            choosen.push((typeof element.value == 'object' ? element.value._id : element.value))
            // choosen.push((element.value))

        });
        // console.log(choosen)
        this.props.changeValue(this.props.header.key, choosen, this.props.extra)
    }


    openEdit = () => {
        this.sidebarView.open()
        setTimeout(() => {
            this.fixedView.hideView()
        }, 100);
        this.setState({ editIsOpen: true })
    }

    onClosed = () => {
        this.setState({ editIsOpen: false }, () => {
            this.toggleOpen(true)
        })
    }


    openItemModal = () => {
        this.itemModal.open()
    }

    itemAdded = (data) => {

    }

    itemEdited = (data) => {

    }


    showOptions = (data, viewMode) => {
        if (data && Array.isArray(data)) {
            return (
                <div className={" flex-wrap " + (viewMode ? 'flexc' : '')}>
                    {data.map((prop, index) => {
                        let selected = false
                        for (let i = 0; i < this.state.choosen.length; i++) {

                            if (viewMode && prop.value == this.state.choosen[i].value) {
                                selected = true
                            }
                        }

                        let hasChildren = prop.children && prop.children.length > 0

                        return (
                            <div className="mrd-1 " key={index} style={{ width: hasChildren ? '100%' : null, cursor: 'pointer', }}>
                                <div className="flexc" onClick={() => { if (!hasChildren) { this.changeItem(prop, selected) } }}>
                                    <p className="mb-2 br-20" style={{ margin: 0, color: '#000', fontSize: 13, border: hasChildren ? null : '1px solid #eee', padding: hasChildren ? null : '4px 8px', background: hasChildren ? null : (selected ? (prop.colors?.background ?? '#007aff') : '#f0f0f0'), color: selected ? (prop.colors?.color ?? '#fff') : null }}>{checkTranslation(prop.title)}</p>
                                    {hasChildren && (
                                        <div className="mrd-1 pb-1">
                                            <img src="/assets/icons/angle-right.svg" height={14} />
                                        </div>
                                    )}
                                </div>
                                {hasChildren && (
                                    <div className="px-2">
                                        {this.showOptions(prop.children, viewMode)}
                                    </div>
                                )}
                            </div>
                        )
                    })
                    }
                </div>
            )
        }
    }


    render() {

        return (
            <div ref={el => this.currentNode = el} className='mt-0 w-100 h-100 flexc' style={{ position: 'relative', minHeight: 20 }} onClick={() => { if (!this.state.editIsOpen) { this.toggleOpen(true) } }} >
                {/* <div ref={ref => this.setWrapperRef(ref)} className='mt-0 w-100 h-100 flexc' style={{ position: 'relative' }} onClick={() => this.toggleOpen(true)} > */}





                {/* <span style={{ opacity: 0 }}>0</span> */}

                {!this.state.choosen?.length && (
                    <div className="h-100 flexc" style={{ position: 'absolute', top: 0 }}>
                        <label className={' mrd-1 mld-1 placeholder '}>{checkTextTranslation(this.props.header.information.placeholder ?? 'Select...')}</label>
                    </div>
                )}

                <div className="wrapper w-100"  >
                    <div style={{ flexWrap: 'wrap', borderRadius: 4, cursor: 'pointer', display: 'flex', alignItems: 'center' }}>
                        {this.state.choosen.map((prop, index) => {
                            return (
                                <div key={index} className="" style={{ display: 'inline-flex', alignItems: 'center', paddingTop: 2, paddingBottom: 2 }}>
                                    <div className="flexcc mx-1 br-20 " key={index} style={{ padding: "5px 5px", backgroundColor: prop.colors?.background ?? '#007aff', flexWrap: 'nowrap' }}>
                                        <p className="pld-1" style={{ whiteSpace: 'nowrap', marginBottom: 0, marginRight: 2, marginLeft: 2, fontSize: 12, marginTop: 0, color: prop.colors?.color ?? '#fff' }}>{checkTranslation(prop.title)}</p>
                                        <div className="flexcc br-20 mld-1" style={{ height: 18, width: 18, backgroundColor: '#00000060' }}>
                                            <img className="invert" src="/assets/icons/close.svg" onClick={() => this.removeItem(index)} style={{ width: 14, height: 14 }} />
                                        </div>
                                    </div>
                                    {/* {index != this.state.choosen.length - 1 && (
                                        <i className="fa fa-arrow-right" style={{ color: '#78b2d0' }}></i>

                                    )} */}
                                </div>
                            )
                        })}
                        {/* <div className={"position-relative mt-0 mld-1 "}> */}
                        {/* {!this.state.isFinal && (
                                <input ref={'input'} value={this.state.title} onFocus={() => { this.toggleOpen() }} onInput={event => this.search(event.target.value)} onChange={e => { this.props.changeValue(this.props.headerkey, e.target.value) }} className='nofocus mediumiransansfont' style={{ backgroundColor: 'transparent', minWidth: 100, width: this.state.title.length * 9, border: 'none' }} />
                            )} */}
                        {this.state.isLoading && (

                            <div style={{ position: 'absolute', top: 0, right: 5 }}>
                                <Loader
                                    type="Oval"
                                    color="rgba(0,122,255,1)"
                                    height="20"
                                    width="20"
                                />
                            </div>
                        )}

                        {this.state.isFinal && (<i className="fa fa-check-circle mld-1" style={{ color: '#78b2d0', fontSize: 20 }}></i>)}

                    </div>

                    <FixedView ref={el => this.fixedView = el} nodeRef={this.currentNode} onHide={this.onHide} topOffset={10} bottomOffset={28} zIndex={15} xOffset={0} rightAlign={false} width={300}>

                        <div className="w-100 pb-2 br-6" style={{ maxWidth: 300, zIndex: 40, backgroundColor: '#ffffff', boxShadow: '0px 0px 10px rgba(0,0,0,0.1)' }}>
                            <div className={'search-drop-down '} style={{ display: 'flex', flexDirection: 'column', width: '100%', maxHeight: 320, overflow: 'auto', }}>
                                {/* {this.props.header.information.isSearchable && ( */}
                                <input onChange={event => this.search(event.target.value)} placeholder={translate("Search ...")} style={{ fontSize: 13, alignSelf: 'stratch', padding: 5, margin: 5, height: 35, backgroundColor: '#f7f7f7', borderRadius: 4, borderWidth: 1, borderStyle: 'solid', borderColor: '#eee', marginTop: 5 }} className={'text-start'} />
                                {/* )} */}

                                {this.state.options?.length > 0 && (

                                    <div className="px-3 py-2">
                                        {this.showOptions(this.state.options, true)}

                                    </div>
                                )}

                                {this.state.options.length == 0 && (
                                    <div style={{ cursor: 'pointer', padding: 5, paddingTop: 10, paddingBottom: 10, borderBottomColor: '#eee', borderBottomStyle: 'solid', borderBottomWidth: 1 }}>
                                        <p style={{ textAlign: 'center', margin: 0, color: '#000', opacity: 0.5, fontSize: 13 }}>{translate("useful.foundNothing")}</p>
                                        {this.props.header.information.tag && this.state.title != '' && (<p onClick={() => this.addTag()} style={{ textAlign: 'center', margin: 0, color: '#007aff', fontSize: 13, marginTop: 5, marginBottom: 5, cursor: 'pointer' }}>+ ADD THIS</p>)}

                                    </div>
                                )}
                            </div>



                            <div className='flexcb pt-2 px-3 w-100' style={{ borderTop: '1px solid #f0f0f0' }}>
                                <button onClick={() => this.openEdit()} className='flexc cursor-pointer' style={{ color: '#999' }}>
                                    <p>{translate('Edit Mode')}</p>
                                </button>

                                <div className=' flexc cursor-pointer' onClick={() => this.changeValue()}>
                                    <p className="text-capitalize text-smaller text-center px-1" style={{ color: '#007aff' }}>Clear</p>
                                </div>
                            </div>
                        </div>
                    </FixedView>



                    <SidebarView onClosed={this.onClosed} width={this.props.width} ref={el => this.sidebarView = el} hideOverlay={false} widthCondition={{ xs: "60%", sm: "50%", md: '60%', lg: "50%", xl: "40%" }} left={50}>

                        <div className="px-2 w-100 h-100" style={{ overflow: 'auto' }}>

                            <div className="pt-3 flexcb w-100">
                                <p className="text-semibold text-normal">{translate("Options Editor")}</p>

                                <button className=' flexc cursor-pointer ' >
                                    <p className="text-capitalize text-small text-center px-1" style={{ color: '#007aff' }}>Done</p>
                                </button>

                            </div>

                            <div className="px-3 py-2">
                                {this.showOptions(this.state.options)}
                            </div>


                            {this.state.options.length == 0 && (
                                <div style={{ cursor: 'pointer', padding: 5, paddingTop: 10, paddingBottom: 10, borderBottomColor: '#eee', borderBottomStyle: 'solid', borderBottomWidth: 1 }}>
                                    <p style={{ textAlign: 'center', margin: 0, color: '#000', opacity: 0.5, fontSize: 13 }}>{translate("useful.foundNothing")}</p>
                                    {this.props.header.information.tag && this.state.title != '' && (<p onClick={() => this.addTag()} style={{ textAlign: 'center', margin: 0, color: '#007aff', fontSize: 13, marginTop: 5, marginBottom: 5, cursor: 'pointer' }}>+ ADD THIS</p>)}
                                </div>
                            )}

                            <div className=' flexc cursor-pointer mt-2' onClick={() => this.openItemModal()}>
                                <p className="text-capitalize text-smaller text-center px-1" style={{ color: '#007aff' }}>+ Add Another Option</p>
                            </div>


                        </div>
                    </SidebarView>





                    <ItemModal
                        ref={el => this.itemModal = el}
                        page={this.state.page}
                        headers={this.state.page.headers}
                        initData={this.state.currentItem}
                        itemAdded={this.itemAdded}
                        itemEdited={this.itemEdited}
                        variables={this.props.variables}
                    />



                </div>



            </div>
        );
    }
}


export default MultiSelectInput;
